export default __webpack_public_path__ + "static/team-image-6bb4f520373a61c05f515517057750d5.webp";